import { RxDocument, RxCollection, RxJsonSchema, RxCollectionCreator } from 'rxdb';
import { ApsAssignedList } from '../models/aps-assigned-list';
import * as moment from 'moment';

export const apsAssigned: RxJsonSchema<ApsAssignedList> = {
  title: 'Aps Assigned List',
  description: 'This is the Aps Assigned List',
  version: 1,
  keyCompression: true,
  type: 'object',
  properties: {
    aps_report_load_id: {
      type: 'string',
      primary: true
    },
    aps_case_load_id: {
      type: 'number',
      encrypted: true
    },
    abuser_last_name: {
      type: 'string',
      encrypted: true
    },
    date_completed: {
      type: 'string',
      encrypted: true
    },
    days_open: {
      type: 'number',
      encrypted: true
    },
    region: {
      type: 'string',
      encrypted: true
    },
    self_neglect: {
      type: 'boolean',
      encrypted: true
    },
    victim_first_name: {
      type: 'string',
      encrypted: true
    },
    victim_last_name: {
      type: 'string',
      encrypted: true
    },
    assigned_agent_id: {
      type: 'number'
    },
    assigned_agent: {
      type: 'string'
    },
    date_created: {
      type: 'string'
    }
  }
};

export type ApsAssignedDocument = RxDocument<ApsAssignedList>;
export type ApsAssignedCollection = RxCollection<ApsAssignedList>;

export const apsAssignedCollection: RxCollectionCreator = {
  name: 'aps_assigned_list',
  schema: apsAssigned,
  migrationStrategies: {
    1: (oldData) => {
      oldData.date_created = moment().format('MM/DD/YYYY HH:mm');
      return oldData;
    }
  }
};
